import { render, staticRenderFns } from "./editDoctor.vue?vue&type=template&id=71354f44&scoped=true"
import script from "./editDoctor.vue?vue&type=script&lang=js"
export * from "./editDoctor.vue?vue&type=script&lang=js"
import style0 from "./editDoctor.vue?vue&type=style&index=0&id=71354f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71354f44",
  null
  
)

export default component.exports